import {Injectable} from "@angular/core";
import {Map} from "leaflet";
import {List} from "immutable";


@Injectable()
export class MapService {
    constructor() {
    }
}



// WEBPACK FOOTER //
// ./src/app/services/map.service.ts